import { IAttachment } from "../../components/mstchat/chatMessage";

export enum RoomSummaryEventTag {
  SummaryTextMessage = "summary_text_message",
  SummaryAttachmentsMessage = "summary_attachments_message",
  SummaryLektaMessage = "summary_lekta_message"
}

export interface RoomSummaryTextMessage {
  tag: RoomSummaryEventTag.SummaryTextMessage;
  authorId: string;
  message: string;
  timestamp: number;
}

export interface RoomSummaryAttachmentsMessage {
  tag: RoomSummaryEventTag.SummaryAttachmentsMessage;
  authorId: string;
  timestamp: number;
  message?: string;
  context: {
    message?: string;
    attachments: IAttachment[];
  };
}

export interface RoomSummaryLektaMessage {
  tag: RoomSummaryEventTag.SummaryLektaMessage;
  authorId: string;
  message: string;
  timestamp: number;
  context: {
    message?: string;
  };
}

export type RoomSummaryEvent =
  | RoomSummaryTextMessage
  | RoomSummaryAttachmentsMessage
  | RoomSummaryLektaMessage;

export interface RoomSummaryContext {
  events: RoomSummaryEvent[];
  roomId: string;
}
